/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { QuestionAnswer } from './questionAnswer';
import type { ContentStudioStage3RequestConfig } from './contentStudioStage3RequestConfig';

/**
 * Input: Answers to strategy questions.
 */
export interface ContentStudioStage3Request {
  answers: QuestionAnswer[];
  selectedNodeIds: string[];
  originalPrompt: string;
  scopeSummary: string;
  config?: ContentStudioStage3RequestConfig;
}
